var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card shadow-sm" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h5", { staticClass: "card-title" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("pages.account.change_password.title")) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.updatePassword($event)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "password" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("pages.account.change_password.password"))
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.$errors.has("password") },
                  attrs: {
                    type: "password",
                    id: "password",
                    placeholder: _vm.$t(
                      "pages.account.change_password.password"
                    )
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("error", { attrs: { input: "password" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "password_confirmation" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pages.account.change_password.password_confirm")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password_confirmation,
                      expression: "password_confirmation"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "is-invalid": _vm.$errors.has("password_confirmation")
                  },
                  attrs: {
                    type: "password",
                    id: "password_confirmation",
                    placeholder: _vm.$t(
                      "pages.account.change_password.password_confirm"
                    )
                  },
                  domProps: { value: _vm.password_confirmation },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password_confirmation = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("error", { attrs: { input: "password_confirmation" } }),
                _vm._v(" "),
                _c("button", { staticClass: "btn btn-outline-dark mt-4" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$t("pages.account.change_password.change_password")
                      ) +
                      "\n                    "
                  )
                ])
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }